module.exports = __webpack_public_path__ + "img/typing_1.1bb883ba.png";